import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-zap',
  templateUrl: './zap.component.html',
  styleUrls: ['./zap.component.scss']
})
export class ZapComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {
  }


}
